import { CTrackerTimelineProps } from ".";
import CancelIcon from "@mui/icons-material/Cancel";
import SettingsIcon from "@mui/icons-material/Settings";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTheme } from "@mui/material";

const CTimelineDot: React.FC<Pick<CTrackerTimelineProps, "status">> = ({
  status,
}) => {
  const theme = useTheme();

  if (status === "analyzing")
    return (
      <SettingsIcon
        sx={{ mt: 0.5 }}
        fontSize="large"
        htmlColor={theme.palette.warning.main}
      />
    );
  if (status === "success")
    return (
      <CheckCircleIcon
        sx={{ mt: 0.5 }}
        fontSize="large"
        htmlColor={theme.palette.success.main}
      />
    );
  if (status === "failed")
    return (
      <CancelIcon
        fontSize="large"
        htmlColor={theme.palette.error.main}
        sx={{ mt: 0.5 }}
      />
    );
  return (
    <CheckCircleIcon
      fontSize="large"
      sx={{ mt: 0.5 }}
      htmlColor={theme.palette.text.disabled}
    />
  );
};

export default CTimelineDot;
